<template>
	<div>
		<div v-if="wizard" class="question-container">
			<div class="question">
				<div class="question-title">{{ wizard.name }}</div>
				<div class="question-value">{{ wizard.question.value }}</div>
			</div>

			<div v-if="isQuestion" class="answer-container">
				<div v-for="(a, i) in wizard.question.map" :key="i" class="answer" @click="processAnswer(a.ref)">
					<!-- <div class="icon">
						<md-icon>drive_file_rename_outline</md-icon>
					</div> -->
					<!-- quello che preferisci: sopra icona matitina, sotto cerchietto che si riempe all'hover -->
					<div class="icon">
						<div class="round">
							<div class="small-round"></div>
						</div>
					</div>
					<div class="text">{{ a.value }}</div>
				</div>

				<!-- <el-radio-group
					style="display: flex; flex-direction: column"
					@change="processAnswer()"
					v-model="answer"
				>
					<el-radio style="margin: 15px" v-for="answ in wizard.question.map" :label="answ.ref">{{
						answ.value
					}}</el-radio>
				</el-radio-group> -->
			</div>
			<div v-else>
				<wizard-answer-render @add="value => $emit('add', value)" :array="wizard.value"></wizard-answer-render>
			</div>
		</div>
		<loading-generic v-else :is-loading="true"></loading-generic>
	</div>
</template>
<script>
import axios from "axios"
import WizardAnswerRender from "@/modules/wizard/modals/wizard-answer-render"
import LoadingGeneric from "@/modules/_common/loading-generic"

export default {
	name: "wizard-render",
	components: { LoadingGeneric, WizardAnswerRender },
	props: ["id"],
	data() {
		return {
			wizard: undefined,
			answer: undefined
		}
	},
	computed: {
		isQuestion() {
			return this.wizard.question.value !== ""
		}
	},
	mounted() {
		this.loadWizard()
	},
	methods: {
		loadWizard() {
			axios
				.post(
					process.env.VUE_APP_API_URL + "/api/wizard/get/" + this.id,
					{},
					{
						headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
					}
				)
				.then(res => {
					setTimeout(() => {
						this.wizard = res.data.node
						if (this.wizard.question == '{"map": [], "value": ""}')
							this.wizard.question = '{"map": [{"ref": null, "value": ""}], "value": ""}'
						this.wizard.question = JSON.parse(this.wizard.question)
						this.wizard.value = JSON.parse(this.wizard.value)
						if (this.wizard.value[0].type == "wizard") {
							this.$emit("replace", this.wizard.value[0].id)
						}
					}, 500)
				})
				.catch(err => console.error(err))
		},
		processAnswer(a) {
			this.answer = a

			this.$emit("change", this.answer)
			this.answer = undefined
		}
	}
}
</script>
<style scoped lang="scss">
.question-container {
	display: flex;
	flex-direction: column;
	height: 100%;
	.question {
		display: flex;
		flex-direction: column;
		width: 100%;
		align-items: center;
		justify-content: center;
		.question-title {
			font-size: 1.2rem;
			font-weight: 400;
		}
		.question-value {
			padding-top: 10px;
			font-size: 1.3rem;
			font-weight: 600;
		}
	}
	.answer-container {
		padding-top: 10px;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		width: 100%;
		.answer {
			min-width: 220px;
			width: 220px;
			margin: 10px 0;
			height: 70px;
			border: 1pt solid #ccc;
			display: flex;
			border-radius: 7px;
			cursor: pointer;
			padding: 10px;
			transition: all 0.25s ease-in-out;
			.icon {
				width: 25%;
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				.round {
					width: 40px;
					height: 40px;
					border: 2pt solid #ccc;
					display: flex;
					border-radius: 50%;
					justify-content: center;
					align-items: center;
					.small-round {
						width: 25px;
						height: 25px;
						border-radius: 50%;
						background-color: #00c06a;
						opacity: 0;
					}
				}
			}
			.text {
				width: 75%;
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 1.2rem;
				font-weight: 700;
			}
			&:hover {
				box-shadow: 0 1px 5px #00c06a;
				.icon > .round > .small-round {
					opacity: 1;
				}
				.icon i {
					color: #00c06a;
				}
			}
		}
	}
}
</style>
